import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import GlobalCard from "../../components/GlobalCardComponent";
import NewServiceCard from "./NewServiceCard";
import SubservicePopup from "../../components/customPopup/SubservicePopup";
import TestPrepSubserviceComp from "./dashboardComp/subServiceCard/TestPrepSubserviceComp";
import SabSubserviceComp from "./dashboardComp/subServiceCard/SabSubserviceComp";
import StudyAbroadBanner from "./StudyAbroadBanner";
import ProfileCard from "./dashboardComp/profilecard/ProfileCard";
import {
  GetTestMasterIssEnroll,
  getTestTypeByUser,
  getUserDetails,
} from "./Api/DashboardApi";
import RunningClassesDashboard from "./dashboardComp/classes/RunningClassesDashboard";
import DashboardCalendar from "./dashboardComp/calaendar/DashboardCalendar";
import SubSeriviceCards from "./dashboardComp/subServiceCard/SubSeriviceCards";
import GoalTrackerCard from "./dashboardComp/testPrepGoalCard/GoalTrackerCard";
import TestBanner from "./dashboardComp/testBanner/TestBanner";
import BookDemoCard from "./dashboardComp/bookDemoCard/BookDemoCard";
import TestPrepSliderBanner from "./dashboardComp/testBanner/TestPrepBanners";
import UpdatedProfileCard from "./dashboardComp/profilecard/UpdatedProfileCard";
import TaskAndEnrolledDetails from "./dashboardComp/taskAndEnrolledCard/TaskAndEnrolledDetails";
import DashboardBlogs from "./dashboardComp/dashboardBlogs/DashboardBlogs";
import PerformanceReport from "./dashboardComp/dashboardPerformance/pages/PerformanceReport";
import PinkExtraSmallButton from "../../components/customButtons/PinkExtraSmallButton";
import { useNavigate } from "react-router-dom";
import UpcommingSessionCalendar from "./dashboardComp/upcommingSessionCalander/UpcommingSessionCalander";
import NewBookDemoCard from "./dashboardComp/bookDemoCard/NewBookDemoCard";
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export default function NewTestPrepDashboard() {
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const isEnrolled = localStorage.getItem("isEnrolled");
console.log("isEnrolled",isEnrolled)
  const [userDetails, setUserDetails] = useState([]);
  const [userLoading, setUserLoading] = useState(false);
  const [goalDetails, setGoalDetails] = useState([]);
  const [testTypeList, setTestTypelIst] = useState([]);
  const [goalLoading, setGoalLoading] = useState(true);

  // FetchUserdetails
  useEffect(() => {
    const fetchUser = async () => {
      setUserLoading(true);
      try {
        const data = await getUserDetails(userId);
        setUserDetails(data);
      } catch (err) {
        console.error("Could not fetch user details");
      } finally {
        setUserLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  // fetch goal details

  useEffect(() => {
    const fetchUser = async () => {
      setUserLoading(true);
      try {
        const data = await getTestTypeByUser(userId);
        setTestTypelIst(data);
      } catch (err) {
        console.error("Could not fetch user details");
      } finally {
        setGoalLoading(false);
      }
    };

    fetchUser();
  }, [userId]);

  const navigateTosapDashboard = () => {
    navigate("/sap/dashboard");
  };

  return (
    <>
      {isEnrolled==="true" ? (
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "stretch" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <SubSeriviceCards />

            <TaskAndEnrolledDetails />
            <PerformanceReport />
          </Grid>

          <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
            <Card
              sx={{
                p: 2,

                borderRadius: "22px",
                boxShadow: "0px 0px 3.81px rgba(0, 0, 0, 0.25)",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid container sx={{ flex: 1 }}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                >
                  {/* <ProfileCard userDetails={userDetails} /> */}
                  {/* <UpdatedProfileCard userDetails={userDetails} /> */}
                  <Grid container>
                    {" "}
                    <Grid item xs={12} textAlign="center">
                      <PinkExtraSmallButton
                        onClick={navigateTosapDashboard}
                        buttonTitle="Switch to Scholars Admission Program"
                        endIcon={
                          <img
                            src="/newdashboard/ProfileSection/XMLID_1523_.png"
                            style={{ width: 20.9 }}
                          />
                        }
                        borderRadius="12px"
                      />
                    </Grid>
                  </Grid>

                  <Box
                    sx={{
                      height: {
                        xs: "auto", // mobile: natural height
                        md: "720px", // desktop: fixed height
                      },

                      minHeight: 0,
                      overflowY: "auto", // enable vertical scroll
                      pr: 1, // optional: space for scrollbar
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#999999", // purple like your screenshot
                        borderRadius: "3px",
                      },
                      "&:hover::-webkit-scrollbar-thumb": {
                        backgroundColor: "#999999", // purple on hover
                      },
                      "&::-webkit-scrollbar-track": {
                        background: "#f5f5f5",
                        borderRadius: "3px",
                      },
                    }}
                  >
                    <Stack direction="column" spacing={2}>
                      <GoalTrackerCard
                        testTypeList={testTypeList}
                        goalLoading={goalLoading}
                      />{" "}
                      <UpcommingSessionCalendar />
                    </Stack>
                  </Box>
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          spacing={2}
          sx={{ display: "flex", alignItems: "stretch" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            md={8}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <SubSeriviceCards />

            <TestPrepSliderBanner />

            <RunningClassesDashboard />

            {/* <DashboardBlogs /> */}
          </Grid>

          <Grid item xs={12} sm={12} md={4} sx={{ display: "flex" }}>
            <Card
              sx={{
                p: 2,

                borderRadius: "22px",
                boxShadow: "0px 0px 3.81px rgba(0, 0, 0, 0.25)",
                flex: 1,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid container sx={{ flex: 1 }}>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", flexDirection: "column", gap: 2 }}
                >
                  {/* <ProfileCard userDetails={userDetails} /> */}
                  {/* <UpdatedProfileCard userDetails={userDetails} /> */}
                  <Grid container>
                    {" "}
                    <Grid item xs={12} textAlign="center">
                      <PinkExtraSmallButton
                        onClick={navigateTosapDashboard}
                        buttonTitle="Switch to Scholars Admission Program"
                        endIcon={
                          <img
                            src="/newdashboard/ProfileSection/XMLID_1523_.png"
                            style={{ width: 20.9 }}
                          />
                        }
                        borderRadius="12px"
                      />
                    </Grid>
                  </Grid>
                  <GoalTrackerCard
                    testTypeList={testTypeList}
                    goalLoading={goalLoading}
                  />{" "}
                  <NewBookDemoCard />
                </Grid>
              </Grid>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
}
